export const calculateAge = (dob: Date, onDate: Date): number => {
  if (isNaN(dob.getTime())) return NaN;

  let age = onDate.getFullYear() - dob.getFullYear();
  const monthDiff = onDate.getMonth() - dob.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && onDate.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
};

export const parseDateString = (dobStr: string): Date | null => {
  if (!dobStr) return null;

  const parts = dobStr.includes("/") ? dobStr.split("/") : dobStr.split("-");
  if (parts.length !== 3) return null;

  let day: number, month: number, year: number;

  if (parts[0].length === 4) {
    // yyyy-mm-dd
    year = Number(parts[0]);
    month = Number(parts[1]);
    day = Number(parts[2]);
  } else {
    // dd-mm-yyyy
    day = Number(parts[0]);
    month = Number(parts[1]);
    year = Number(parts[2]);
  }

  const dob = new Date(year, month - 1, day);
  return isNaN(dob.getTime()) ? null : dob;
};
